import { NavigationExtras } from '@angular/router';
import { Observable, Subject } from 'rxjs/Rx';
import { Application } from './shared/services/app/application/application.model';
import { Page, Event, NavItem, Pod, Promotion, Test } from './shared/services/app/content/models';
import { MockStudents } from './shared/services/user/student/mock-students';
import { UserApplicationProperties } from 'app/shared/services/user/user-application-properties.model';
import { StudentGroup } from 'app/shared/services/user/student/student-group.model';
import { GlobalUser } from 'app/shared/services/user/global-user.model';
import { AppUser } from 'app/shared/services/user/app-user.model';
import { ActiveUser } from 'app/shared/services/user/active-user.model';
import { FormGroup } from '@angular/forms';

/// I went ahead and alphabetized all of these except for Page Service Stub ///
/// Page Service Stub is used by other stubs, so it needs to be first, also all the AngularFireStub Classes are still at the bottom ///

export let PageServiceStub = {
  pages() { return [
        {name: 'title', description: 'description', id: '1', position: 1, type: 'page', content: 'content', url: 'url'},
        {name: 'title2', description: 'description', id: '2', position: 2, type: 'page', content: 'content', url: 'url'},
        {name: 'title3', description: 'description', id: '3', position: 3, type: 'folder', content: 'content', url: 'url', firebaseUrl: 'firebaseurl'}, // parent
        {name: 'different', description: 'description', id: '4', position: 4, type: 'page', content: 'content', firebaseUrl: 'url'}
      ]; },

  createEditPage(page: any, pageUrl?: string) {
    let pages: any[] = this.pages();
    if (!pageUrl) {
      pages[pages.length] = page;
    } else { // assume unique firebase url
      pages.forEach((singlePage) => {
        if (singlePage.firebaseUrl === pageUrl) {
          singlePage.name = page.name;
          singlePage.description = page.description;
        }
      });
    }
    return Promise.resolve(pages);
  },
  findPageByID(id: string) {
    return {name: 'page', type: 'folder', id: 'abc123'};
  }
};

export let ActivatedRouteStub = {
  snapshot: {url: [{path: 'tests'}], params: {id: 3}}
};

export let AnalyticsServiceStub = {
  clearAppAnalytics() { return; }
};

export let ApplicationServiceStub = {
  _currentApp: new Application({sys_name: 'brain', permissions: ['pods', 'ads', 'push-notifications', 'training'], logo: 'logo',
  settings: {app_id: 'brain', app_name: 'brain', descr: 'thinks', version: '1.1.1'}}),
  getApplicationDetails(string) {
    this._currentApp = new Application({sys_name: 'brain', permissions: ['pods', 'ads', 'push-notifications', 'training'], logo: 'logo',
                                        settings: {app_id: 'brain', app_name: 'brain', descr: 'thinks', version: '1.1.1'}});
    return Promise.resolve(this._currentApp);
  },
  getVersionHistory() {
    return Promise.resolve([]);
  },
  getAppFeatures(includeStandardFeatures?: boolean) {
    let appFeats = [
    { display_name: 'Home Screen Pods', system_name: 'pods',  icon: 'oi oi-menu', selected: false },
    { display_name: 'Promotions', system_name: 'ads',  icon: 'oi oi-bookmark', selected: false },
    { display_name: 'Push Notifications', system_name: 'push-notifications', icon: 'oi oi-bell', selected: false },
    { display_name: 'Training', system_name: 'training', icon: 'oi oi-book', selected: false },
    { display_name: 'Messages', system_name: 'messages', icon: 'oi oi-chat', selected: false },
    { display_name: 'Calendar', system_name: 'events', icon: 'oi oi-calendar', selected: false },
    { display_name: 'iBeacons', system_name: 'ibeacons', icon: 'oi oi-location', selected: false }
  ];
  appFeats = appFeats.filter(feature => this._currentApp.hasFeature(feature.system_name));
    if (includeStandardFeatures) {
      appFeats.push({ display_name: 'App Content', system_name: 'pages', icon: 'oi oi-document', selected: false });
      appFeats.push({ display_name: 'Navigation', system_name: 'nav-items', icon: 'oi oi-menu', selected: false });
    }
    return appFeats;
  },
  get defaultFeatures() {
    return [
      { display_name: 'Home Screen Pods', system_name: 'pods',  icon: 'oi oi-menu', selected: false },
      { display_name: 'Promotions', system_name: 'ads',  icon: 'oi oi-bookmark', selected: false },
      { display_name: 'Push Notifications', system_name: 'push-notifications', icon: 'oi oi-bell', selected: false },
      { display_name: 'Training', system_name: 'training', icon: 'oi oi-book', selected: false },
      { display_name: 'Messages', system_name: 'messages', icon: 'oi oi-chat', selected: false },
      { display_name: 'Calendar', system_name: 'events', icon: 'oi oi-calendar', selected: false },
      { display_name: 'iBeacons', system_name: 'ibeacons', icon: 'oi oi-location', selected: false }
    ];
  },

  getApplicationMobileSettings(sys_name) {
    return Promise.resolve({ primary_color: '#aaabbb', secondary_color: '#bbbaaa', font_family: 'fonto', android_app_icon: 'android',
                             ios_app_icon: 'ios', color_logo: 'color', white_logo: 'white', doorbell_id: 'door', doorbell_key: 'door-key',
                             client_web_tracking_id: 'web', client_mobile_tracking_id: 'mobile', play_store_rate: 'play',
                             app_store_rate: 'ios', terms_and_conditions: '1', facebook: 'face', instagram: 'insta', twitter: 'twit',
                             linkedin: 'link', youtube: 'you', soundcloud: 'sound'});
  }

 };

 export let AppBuilderServiceStub = {
  assignedAdmins: [],
  defaultFeatures: ApplicationServiceStub.defaultFeatures.slice(),
  getReset: function(key: string) { return new Subject<any>(); },
  includePush: true,
  removeFeature: function(feature: any) {
    feature.selected = false;
  },
  updateForm: function(form: FormGroup, key: string, editMode?: boolean) { },
  initAWSPush: function(appFeatures: any[]) { },
  assignUser: function(user: GlobalUser) {
    this.assignedAdmins.push(user);
  },
  removeUser: function(user: GlobalUser) {
    this.assignedAdmins = this.assignedAdmins.filter(each => {
      return each !== user;
    });
  },
  get selectedFeatures() {
    return this.defaultFeatures.filter(feature => feature.selected);
  }
 };

export let ChildrenOutletContextsStub = {
  onChildOutletCreated() { return; },
  getContext() { return; }
};

export let ContentServiceStub = {
  events: {
    events: [new Event({title: 'one', startDateTime: new Date(1999, 5, 4), endDateTime: new Date(1999, 5, 5), label: 'label' }),
             new Event({title: 'title2', startDateTime: new Date(2017, 10, 4), endDateTime: new Date(2017, 10, 5), label: '2'}),
             new Event({title: 'one2', startDateTime: new Date(2017, 10, 3), endDateTime: new Date(2017, 10, 5), label: '2'}),
            ],
    sortAscending(input: Event[]) {
      let order = input.sort((a, b) => {
        let firstStart = new Date(a.startDateTime);
        let secondStart = new Date(b.startDateTime);
        return firstStart < secondStart ? -1 : firstStart > secondStart ? 1 : 0;
      });
      return order;
    }
  },
  pages: {
    savePage(value, url?) {},
    firebaseObservable : {
      subscribe(e) { e(); } // runs fat arrow function after subscribe
    },
    flatPages: PageServiceStub.pages()
  }
};

export let CsvServiceStub = {
  dummyUserImportParse(num) {
    return [
      ['tyler1', 'schreiver1', 'tyler.schreiver+1@interapt.com'],
      ['tyler2', 'schreiver2', 'tyler.schreiver+2@interapt.com'],
      ['tyler3', 'schreiver3', 'tyler.schreiver+3@interapt.com'],
      ['tyler4', 'schreiver4', 'tyler.schreiver+4@interapt.com'],
      ['tyler5', 'schreiver5', 'tyler.schreiver+5@interapt.com'],
      ['tyler6', 'schreiver6', 'tyler.schreiver+6@interapt.com']
    ];
  }
};

export let CalendarServiceStub = {
  getRootEvents(app?) { return; }
};

export let FileDownloadServiceStub = {
  downloadCSV(file: string, name: string) { }
};

export let ImageUploadServiceStub = {
    MOCK_IMAGES: ['http://lorempixel.com/200/300',
                  'http://lorempixel.com/100/300',
                  'http://lorempixel.com/600/200',
                  'http://lorempixel.com/200/400',
                  'http://lorempixel.com/500/300',
                  'http://lorempixel.com/700/400',
                  'http://lorempixel.com/700/500',
                  'http://lorempixel.com/600/600',
                  'http://lorempixel.com/200/700',
                  'http://lorempixel.com/500/800',
                  'http://lorempixel.com/200/900',
                  'http://lorempixel.com/800/700',
                  'http://lorempixel.com/600/500',
                  'http://lorempixel.com/200/800',
                  'http://lorempixel.com/500/200'],
  getAllAWSImagesByApp(sysName: string) {
    return Promise.resolve(this.MOCK_IMAGES);
  }
};

export let ImagePreloadServiceStub = {
  imageContextLoaded: new Subject(),
  preloadImagesWithURLs(urls, id) {},
};

export let ImageServiceStub = {
  imageCropped: {
    subscribe(e) { return e(); }
  },
  imageSelected: {
    subscribe(e) { return e(); }
  }
};

export let LessonsServiceStub = {
  lessons: [new Page({name: 'name', content_type: 'training', training_obj: {subtype: 'lesson', id: 'id'}}),
          new Page({name: 'name2', content_type: 'training', training_obj: {subtype: 'lesson', id: 'id2'}})],
  selectedIndexTab: '',
  getLesson(id) {
    return Promise.resolve({id: 3, title: 'lesson3', content: [{title: 'Title', text: 'this is your lesson'}],
      questions: [{question_type: 'true-false', correct_answer: 'true', prompt: 'what\'s up?'}], updated_at: new Date(2016, 5, 12)});
  },
  deleteLesson(id) {
    this.lessons.forEach((lesson) => {
      if (lesson.trainingID === id) {
        this.lessons.pop(lesson);
      }
    });
  }
};

export let LoaderStub = {
  show() {},
  hide() {}
};

export let RouterStub = {
  url: '',
  navigate(commands: any[], extras?: NavigationExtras) { },
  navigateByUrl(route: any) { },
  events: {
    subscribe() {
      return;
    }
  }
};

export let SessionStub = {
  masterAppArray: [],
  masterAppHashTable: {},
  getAppFromMasterHash(sysName: string) {
    return this.masterAppHashTable[sysName];
  },
  initializeMasterAppObjects(jsonApps: any[]): any[] {
    let activeUserRoles: UserApplicationProperties[] = [];
    this.masterAppArray = [];
    this.masterAppHashTable = {};

    for (let i = 0; i < jsonApps.length; i++) {
      let app = new Application(jsonApps[i]);
      this.masterAppArray.push(app);
      this.masterAppHashTable[app.sys_name] = app;
      activeUserRoles.push(new UserApplicationProperties(jsonApps[i].role, app));
    }

    this.masterAppArray.sort((a, b) => {
      return a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase());
    });

    return activeUserRoles;
  },
  user(id?) {
    let user: ActiveUser;
    let applications: any[] = [];
    if (!id) {
      user = new ActiveUser({id: 100, first_name: 'Tyler', last_name: 'Schreiverr', global_role: 'client'});
      applications = [{id: 1, is_active: true, sys_name: 'brain', role: 'business_user', settings: {package: 'package'}},
                      {id: 2, is_active: true, sys_name: 'brain2', role: 'business_user', settings: {package: 'package2'}},
                      {id: 3, is_active: false, sys_name: 'brain3', role: 'business_user', settings: {package: 'package3'}},
                      {id: 4, is_active: false, sys_name: 'brain4', role: 'business_user', settings: {package: 'package4'}}];
    }
    switch (id) {
      case '1':
      user = new ActiveUser({id: id, first_name: 'Tyler', last_name: 'Schreiver', global_role: 'super_admin' });
      applications = [{id: 1, sys_name: 'brain', role: 'super_admin'}];
      break;
      case '2':
      user = new ActiveUser({id: id, first_name: 'Tyler', last_name: 'Schreiver', global_role: 'user' });
      applications = [{id: 1, sys_name: 'brain', role: 'mobile_user'}];
      break;
      case '3':
      user = new ActiveUser({id: id, first_name: 'Tyler', last_name: 'Schreiver', global_role: 'client' });
      applications = [{id: 1, sys_name: 'brain', role: 'business_owner'}];
      break;
      default:
      user = new ActiveUser({id: id, first_name: 'Tyler', last_name: 'Schreiverr', global_role: 'client' });
      applications = [{id: 1, sys_name: 'brain', role: 'business_user'}];
      break;
    }
    user.roles = this.initializeMasterAppObjects(applications);
    user.applications = this.masterAppArray;
    user.appHash = this.masterAppHashTable;

    return Promise.resolve(user);
  },
  selectedAppSysName: 'brain',
  headers() { Promise.resolve({}); }
};

export let SessionStubSuperAdmin = {
  masterAppArray: [],
  masterAppHashTable: {},
  getAppFromMasterHash(sysName: string) {
    return this.masterAppHashTable[sysName];
  },
  initializeMasterAppObjects(jsonApps: any[]): any[] {
    let activeUserRoles: UserApplicationProperties[] = [];
    this.masterAppArray = [];
    this.masterAppHashTable = {};

    for (let i = 0; i < jsonApps.length; i++) {
      let app = new Application(jsonApps[i]);
      this.masterAppArray.push(app);
      this.masterAppHashTable[app.sys_name] = app;
      activeUserRoles.push(new UserApplicationProperties(jsonApps[i].role, app));
    }

    this.masterAppArray.sort((a, b) => {
      return a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase());
    });

    return activeUserRoles;
  },
  user(id?) {
    let user: ActiveUser;
    let applications: any[] = [];

    user = new ActiveUser({id: 0, first_name: 'Tyler', last_name: 'Schreiver', global_role: 'super_admin' });
    applications = [{id: 1, is_active: true, sys_name: 'brain', role: 'super_admin', settings: {package: 'package'}},
                    {id: 2, is_active: true, sys_name: 'brain2', role: 'super_admin', settings: {package: 'package2'}},
                    {id: 3, is_active: false, sys_name: 'brain3', role: 'super_admin', settings: {package: 'package3'}},
                    {id: 4, is_active: false, sys_name: 'brain4', role: 'super_admin', settings: {package: 'package4'}}];

    user.roles = this.initializeMasterAppObjects(applications);
    user.applications = this.masterAppArray;
    user.appHash = this.masterAppHashTable;

    return Promise.resolve(user);
  },
  selectedAppSysName: 'brain'
};

export let StudentsServiceStub = {
  selectedIndexTab: '',
  appName: 'brain',
  studentGroups: [],
  studentUsers: [],
  getGroupByTitle(title: string) {
    let group = this.studentGroups.filter(group => group.title === title);
    if (group.length) return group[0];
    return null;
  },
  toggleArchivedStudent(student: any, status: boolean) {
    student.archived = status;
  },
  exportStudents(app: string, students: AppUser[]) {
    return Promise.resolve(
      'First Name;Last Name;Email;\n' +
      'Charlie;Meredith;charlie.meredith@interapt.com;\n' +
      'Jane;Doe;jane.doe@interapt.com;\n');
  },
  getAllGroupsByApp(appName: string, clearCache?: boolean) {
    return Promise.resolve([
      new StudentGroup('Group A', 1, []),
      new StudentGroup('Group B', 2, [])
    ]);
  },
  createGroup(app: Application, title: string, students: AppUser[]) {
    return Promise.resolve()
    .then(() => {
      let counter = this.studentGroups.length + 1;
      let group = new StudentGroup(title, counter, students);
      students.forEach((student) => {
        student.addGroup(group);
        group.addStudent(student);
      });
      this.studentGroups.push(group);
    });
  },
  addStudentsToGroup(app: Application, students: AppUser[], group: StudentGroup) {
    return Promise.resolve()
    .then(() => {
      students.forEach(student => {
        student.addGroup(group);
        group.addStudent(student);
      });
    });
  },
  removeStudentsFromGroup(app: Application, students: AppUser[], group: StudentGroup) {
    return Promise.resolve()
    .then(() => {
      students.forEach(student => {
        student.removeGroup(group);
        group.removeStudent(student);
      });
    });
  },
  updateGroupTitle(app: Application, title: string, group: StudentGroup) {
    return Promise.resolve()
    .then(() => {
      group.title = title;
      group.students.forEach(student => student.updateGroupNames());
    });
  },
  resetExams(app: Application, userId: number, exams: number[]) {
    return Promise.resolve({ score: '10.0' });
  },
  getStudentDetail(app: Application, id: number) {
    return Promise.resolve()
    .then(() => {
      let exams = [
        {grade: 100, id: 1, title: 'Exam 1'},
        {grade: 50, id: 2, title: 'Exam 2'}
      ];

      let studentUser = new AppUser(MockStudents.students[0]);
      let role = MockStudents.students[0].app_role_names[0];
      role.app = app.sys_name;
      studentUser.exams = exams;

      return studentUser;
    });
  }
};

export let ToastStub = {
  error(text: string) { return; },
  success(text: string) { return; }
 };

export let UserServiceStub = {
  allUsers: [],
  deleteGlobaUser(user: any) {
    return Promise.resolve();
  },
  getAllAppUsers(appName: string, clearCache?: boolean): Promise<AppUser[]> {
    return Promise.resolve()
    .then(() => {
      this.allUsers = [
        new AppUser({first_name: 'Joe', id: 0, last_name: 'LastName', groups: ['Group A', 'Group B'], is_enrolled: true}),
        new AppUser({first_name: 'Tom', id: 1, last_name: 'GenericName', groups: ['Group A'], is_enrolled: false, logged_in_seconds: 1001}),
        new AppUser({first_name: 'Suzy', id: 2, last_name: 'Q', groups: ['Group A'], is_enrolled: true}),
        new AppUser({first_name: 'Alecia', id: 3, last_name: 'Person', groups: ['Group B'], is_enrolled: true}),
        new AppUser({first_name: 'Tony', id: 4, last_name: 'Namesen', groups: ['Group B'], is_enrolled: false, logged_in_seconds: 100})
      ];
      return this.allUsers;
    });
  },
  getAppUserDetail(appName: string, id: any) {
    return Promise.resolve(new AppUser({first_name: 'Joe', id: 0, last_name: 'LastName', role: 'business_user', permissions: ['training', 'pages', 'nav-items']}));
  },
  refreshUsers(): Promise<GlobalUser[]> {
    let users = [
      new GlobalUser({first_name: 'Joe', id: 0, last_name: 'LastName'}),
      new GlobalUser({first_name: 'Tom', id: 1, last_name: 'GenericName'}),
      new GlobalUser({first_name: 'Suzy', id: 2, last_name: 'Q'}),
      new GlobalUser({first_name: 'Alecia', id: 3, last_name: 'Person'}),
    ];
    users[0].roles = [new UserApplicationProperties('business_user', new Application({id: 1, sys_name: 'brain'}))];
    users[1].roles = [new UserApplicationProperties('business_user', new Application({id: 1, sys_name: 'brain2'}))];
    users[2].roles = [new UserApplicationProperties('app_manager', new Application({id: 1, sys_name: 'brain'}))];
    users[3].roles = [new UserApplicationProperties('business_user', new Application({id: 1, sys_name: 'brain'}))];
    return Promise.resolve(users);
  },
  getUserPermissions(appName, id) {
    return Promise.resolve([
      { display_name: 'Home Screen Pods', system_name: 'pods',  icon: 'oi oi-menu', selected: false },
      { display_name: 'Promotions', system_name: 'ads',  icon: 'oi oi-bookmark', selected: false },
      { display_name: 'Push Notifications', system_name: 'push-notifications', icon: 'oi oi-bell', selected: false },
      { display_name: 'iBeacons', system_name: 'ibeacons', icon: 'oi oi-location', selected: false }
    ]);
  },
  batchEditUserProfiles(obj: any) {
    if (this.allUsers.length === 0) this.getAllUsersByApp('brain').then((users) => { this.allUsers = users; });
    return Promise.resolve().then(() => {
      let usersToToggle: AppUser[] = this.allUsers.filter(user => {
        for (let i = 0; i < obj.users.length; i++) {
          if (obj.users[i] === user.id) { return true; }
        }
        return false;
      });
      usersToToggle.forEach(user => {
        user.isLocked = obj.is_locked;
      });
    });
  },
  getAppUserById(id: number) {
    return Promise.resolve(new AppUser({first_name: 'Joe', last_name: 'LastName', role: 'business_user', permissions: ['training', 'pages', 'nav-items']}))
  },
  updateAppUserById(id: number, updates: any[]) {
    return 'updateAppUserById called'; // not a log so it doesn't clog the console
  }
};

export let TestsServiceStub = {
  exams: [new Page({name: 'name', content_type: 'training', training_obj: {subtype: 'test', id: 'id'}}),
          new Page({name: 'name2', content_type: 'training', training_obj: {subtype: 'test', id: 'id2'}})],

  getTest(id) {
    return Promise.resolve({id: 3, title: 'title3', type: 'test', updated_at: new Date(2016, 5, 12)});
  },
  createExamOrPracticeTest(test: Test): Promise<any> {
    return Promise.reject({message: 'whoops'});
  },
  deleteTest(type, id) {
    this.exams.forEach((exam) => {
      if (exam.trainingID === id) {
        this.exams.pop(exam);
      }
    });
  }
};




export class AngularFireStub  {
  static db: Database;
  public database;
  constructor() {
    AngularFireStub.db = new Database();
    this.database = AngularFireStub.db;
  }
}

export class Database {
  public rand = Math.floor(Math.random() * 1000);
  public staging_apps;
  constructor() {
    AngularFireStub.db = this;
    this.staging_apps = {
      brain: {
        pages: new FirebaseListObservable([
          new FirebaseObjectObservable(new Page({name: 'page0', firebase_url: '0', id: 'aaabbb'})),
          new FirebaseObjectObservable(new Page({name: 'page1', firebase_url: '1', id: 'yeeeee'})),
        ]),
        nav_items: new FirebaseListObservable([
          new FirebaseObjectObservable(new NavItem({name: 'nav-item0', target: 'aaabbb', id: '1'})),
          new FirebaseObjectObservable(new NavItem({name: 'nav-item1', id: '2'})),
        ]),
        events: new FirebaseListObservable([
          new FirebaseObjectObservable(new Event({title: 'event0', target_page: 'aaabbb', id: '3'})),
          new FirebaseObjectObservable(new Event({title: 'event1', id: '4'})),
        ]),
        pods: new FirebaseListObservable([
          new FirebaseObjectObservable(new Pod({name: 'pod0', target: 'page', target_page: 'aaabbb', $key: '0', id: '5'})),
          new FirebaseObjectObservable(new Pod({name: 'pod1', id: '6'})),
        ]),
        ads: new FirebaseListObservable([
          new FirebaseObjectObservable(new Promotion({title: 'promotion0', target_page: 'aaabbb', target_type: 'page', id: '7'})),
          new FirebaseObjectObservable(new Promotion({title: 'promotion1', trigger_page: 'aaabbb', id: '8'})),
        ])
      }
    };
  }
  object(path: string) {
    if (path) {
      var splitPath = path.split('/');
    }
    let parentFolder = this.list(path);
    if (parentFolder && parentFolder.list) parentFolder = parentFolder.list;
    else if (parentFolder && parentFolder.features) return parentFolder;
    else if (!parentFolder) {
      let thing: any = {}; // this is questionable at best but better than overwriting 4 functions
      thing.update = function() { return; };
      return thing;
    }
    for (var key in parentFolder) {
      if (key === splitPath[splitPath.length - 1]) {
        return parentFolder[key];
      }
    }
  }
  list(path: string) {
    var splitPath = [];
    if (path) {
      splitPath = path.split('/');
    }
    switch (splitPath[splitPath.length - 1]) { //when list is called directly, it'll be the last in the path
      case 'events': return this.staging_apps.brain.events;
      case 'pods': return this.staging_apps.brain.pods;
      case 'nav-items': return this.staging_apps.brain.nav_items;
      case 'pages': return this.staging_apps.brain.pages;
      case 'ads': return this.staging_apps.brain.ads;
      default:
        switch (splitPath[splitPath.length - 2]) { // when called via object, it'll the the second last
          case 'events': return this.staging_apps.brain.events;
          case 'pods': return this.staging_apps.brain.pods;
          case 'nav-items': return this.staging_apps.brain.nav_items;
          case 'pages': return this.staging_apps.brain.pages;
          case 'ads': return this.staging_apps.brain.ads;
          default:
            if (splitPath[splitPath.length - 1] === 'brain' && splitPath[splitPath.length - 2] === 'staging-apps') {
                let app = new App(this.staging_apps.brain);
                return app;
            }
            break;
        }
    }
  }

}

export class FirebaseObjectObservable {
  db: Database;
  obj: any;
  constructor(json) {
    this.db = AngularFireStub.db;
    this.obj = json;
  }

  update(json) {
    for (var key in json) {
      this.obj[key] = json[key];
    }
  }
  set(json) { this.obj = json; }
  remove() {// works on pages
    let brain = this.db.staging_apps.brain;
    brain.pages.list.forEach((page) => {
      if (page.obj.id === this.obj.id) {
        let index = brain.pages.list.indexOf(page);
        brain.pages.list.splice(index, 1);
        return;
      }
    });
  }
}

export class FirebaseListObservable {
  list: FirebaseObjectObservable[];
  constructor(array) { this.list = array; }

  remove() { this.list = null; }
  set(list) { this.list = list; }
  push(obj) {
    let length = this.list.length;
    this.list[length] = new FirebaseObjectObservable(obj);
  }
  update(list) { console.log('update function not created'); }
  map(e) {
    let listOfObjects = this.list.map((firebaseObservable) => {
      return firebaseObservable.obj;
    });
    let obs = Observable.of(e(listOfObjects));
    return obs;
  }
}

export class App {
  features: any;
  constructor(json) { this.features = json; }

  update(e?) {
    let feature;
    for (let key in e) { feature = key; }
    for (let key in this.features) {
     if (key === feature) {
       this.features[key] = e;
     } else if (key === 'nav_items' && feature === 'nav-items') {
       this.features[key] = e;
     }
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/testing-stubs.ts